import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getMemberCheckModule } from '@pass-frontend/features/facility-checkin/data-access';

export function MemberCheckModuleLoader({ children }) {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <DynamicModuleLoader modules={[getMemberCheckModule()]}>
      {children}
    </DynamicModuleLoader>
  );
}

export default MemberCheckModuleLoader;
